import React from "react";

const ErrorMessageBox = ({ title = "Error", message }) => {
  if (!message) return null;

  return (
    <div className="error-message-box mt-3">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99989 0.00488281C3.58265 0.00488281 0.00488281 3.58265 0.00488281 7.99989C0.00488281 12.4171 3.58265 15.9949 7.99989 15.9949C12.4171 15.9949 15.9949 12.4171 15.9949 7.99989C15.9949 3.58265 12.4171 0.00488281 7.99989 0.00488281ZM7.00051 12.9968V10.998H8.99926V12.9968H7.00051ZM7.00051 3.00301V9.99864H8.99926V3.00301H7.00051Z"
          fill="#D14343"
        />
      </svg>

      <div className="error-message-holder">
        <p className="error-message">{title}</p>
        <p className="error-message-text">{message}</p>
      </div>
    </div>
  );
};

export default ErrorMessageBox;
